import axios from '@/services/axios'
/**
 * @typedef {{
    public_key: String,
    image_path: String,
    token: String,
    signature: String,
    expire: Number
  }} Token
 *
 * @returns {Promise<Token[]>}
 */
export const requestToken = async ({ qty = 1 } = {}) => {
  if (qty <= 0) {
    return Promise.resolve([])
  }

  try {
    const { data: response } = await axios.get('/data/private/token', {
      params: {
        qty,
      },
    })
    return Promise.resolve(response.message)
  } catch (err) {
    return Promise.reject(err)
  }
}
